import { action } from 'satcheljs';
import { ClientAttachmentId } from 'owa-client-ids';

export const refreshSharingTipsForAttachment = action(
    'REFRESH_SHARING_TIPS_FOR_ATTACHMENT',
    (attachmentId: ClientAttachmentId) => ({
        attachmentId: attachmentId,
    })
);
